import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import inovaone_api from "@/services/inovaone_api";
import {
  restricoesDoUsuario,
  SEM_RESTRICAO,
  type RestricoesImpressao,
  type UsuarioComRestricoes,
} from "@/lib/restricoesUsuario";

/**
 * Restrições do usuário logado, relidas do cadastro a cada abertura da tela:
 * a troca feita no backoffice vale sem novo login.
 *
 * Falha na leitura mantém o comportamento de hoje (sem restrição) e não
 * derruba a tela: a restrição é de conveniência do cliente, e travar a
 * impressão por uma consulta que falhou pararia a operação.
 */
export function useRestricoesUsuario(): RestricoesImpressao {
  const { usuario } = useAuth();
  const [restricoes, setRestricoes] = useState<RestricoesImpressao>(SEM_RESTRICAO);

  useEffect(() => {
    if (!usuario?._id || !usuario?.id_conta) return;
    let ativo = true;
    inovaone_api
      .get<UsuarioComRestricoes[]>(`/usuario/${usuario.id_conta}/${usuario._id}/*/*/*`)
      .then((resposta) => {
        const dados = Array.isArray(resposta.data) ? resposta.data[0] : null;
        if (ativo) setRestricoes(restricoesDoUsuario(dados));
      })
      .catch((erro) => {
        console.error("Erro ao ler as restrições do usuário:", erro);
      });
    return () => {
      ativo = false;
    };
  }, [usuario?._id, usuario?.id_conta]);

  return restricoes;
}
